var MIN_SIZE = 20;
export function getSpinSize() {
  var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var baseSize = containerSize / scrollRange * containerSize;
  if (isNaN(baseSize)) {
    baseSize = 0;
  }
  baseSize = Math.max(baseSize, MIN_SIZE);
  return Math.floor(baseSize);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-virtual-list/es/utils/scrollbarUtil.js
// module id = 1277
// module chunks = 0